import "jquery";

import * as $ from "jquery";

let viewer;

enum Sd360TourButtonType {
    Home,
    Backward,
    Forward
}

interface ISd360Api {
    tour: ISd360TourApi;
}

export class Sd360Api implements ISd360Api {
    tour: ISd360TourApi;

    constructor(pannellumViewer: Pannellum.Viewer, tour: boolean = false) {
        viewer = pannellumViewer;
        if (tour)
            this.tour = new Sd360TourApi(this);
    }
}

interface ISd360TourApi {
    toolbar: ISd360TourToolbar;

    home(): boolean;
    previousScene(): boolean;
    nextScene(): boolean;

    errorMessage: string;
}

class Sd360TourApi implements ISd360TourApi {
    toolbar: ISd360TourToolbar;
    errorMessage: string;

    constructor(sd360Api: ISd360Api) {
        this.toolbar = new Sd360TourToolbar(this);
        this.errorMessage = "";
    }

    /**
     * Move to first scene in 360 tour
     */
    home(): boolean {
        try {
            var config = viewer.getConfig();
            viewer.loadScene(config.firstScene);
            return true;
        } catch (e) {
            this.errorMessage = (e as Error).message;
            return false;
        }
    }

    /**
     * Move to previous scene in 360 tour
     * 
     * Method uses the order property of scenes
     * Order needs to be a number
     * Order property need not be sequential so this is acceptable [1, 2, 4, 8, 10, 11]
     */
    previousScene(): boolean {
        try {
            var config = viewer.getConfig();
            var current = config.scenes[config.scene].order;
            var orders = Object.values(config.scenes).map(item => (item as any).order).sort((a, b) => a - b);
            var previous = orders.indexOf(current) - 1 < 0 ? orders[orders.length - 1] : orders[orders.indexOf(current) - 1];
            const [sceneId] = Object.entries(config.scenes).find(([key, val]) => (val as any).order === previous);
            viewer.loadScene(sceneId);

            return true;
        } catch (e) {
            this.errorMessage = (e as Error).message;
            return false;
        }
    }

    /**
     * Move to next scene in 360 tour
     */
    nextScene(): boolean {
        try {
            var config = viewer.getConfig();
            var current = config.scenes[config.scene].order;
            var orders = Object.values(config.scenes).map(item => (item as any).order).sort((a, b) => a - b);
            var next = orders.indexOf(current) + 1 > orders.length - 1 ? orders[0] : orders[orders.indexOf(current) + 1];
            const [sceneId] = Object.entries(config.scenes).find(([key, val]) => (val as any).order === next);
            viewer.loadScene(sceneId);

            return true;
        } catch (e) {
            this.errorMessage = (e as Error).message;
            return false;
        } 
        
    }
}

interface ISd360TourToolbar {
    show(): void;
    hide(): void;
    //showButton(button: Sd360TourButtonType): void;
    //hideButton(button: Sd360TourButtonType): void;

    errorMessage: string;
}

class Sd360TourToolbar implements ISd360TourToolbar {
    errorMessage: string;
    #sd360TourApi: ISd360TourApi;

    constructor(sd360TourApi: ISd360TourApi) {
        this.errorMessage = "";
        this.#sd360TourApi = sd360TourApi;
        this.#init();
    }

    #init(): boolean {
        $(".pnlm-container")
            .append(
                "<div id='sd360tour-category-menu'></div>" +
                "<div id='sd360tour-toolbar'>" +
                "<div id='sd360tour-backward' class='pnlm-controls pnlm-control sd360tour-button'><i class='icon ion-md-skip-backward'></i></div>" +
                "<div id='sd360tour-home' class= 'pnlm-controls pnlm-control sd360tour-button'> <i class='icon ion-md-home'></i></div > " +
                "<div id='sd360tour-forward' class='pnlm-controls pnlm-control sd360tour-button'><i class='icon ion-md-skip-forward'></i></div>" +
                "</div>" +
                "<div id='container360fixed'></div>");

        $("#sd360tour-backward").on("click", e => {
            this.#emptyFixedContainer();
            this.#sd360TourApi.previousScene();
        });

        $("#sd360tour-home").on("click", e => {
            this.#emptyFixedContainer();
            this.#sd360TourApi.home();
        });

        $("#sd360tour-forward").on("click", e => {
            this.#emptyFixedContainer();
            this.#sd360TourApi.nextScene();
        });

        // Hide category menu by default
        $(`#sd360tour-category-menu`).addClass("d-none");

        return true;
    }

    show() {
        $(`#sd360tour-toolbar`).removeClass("d-none");
    }

    hide() {
        $(`#sd360tour-toolbar`).addClass("d-none");
    }

    #emptyFixedContainer() {
        $("#container360fixed").empty();
    }

    //showButton(button: Sd360TourButtonType) {
    //    let id = this.#getButtonId(button);
    //    $(`#${id}`).removeClass("d-none");
    //}

    //hideButton(button: Sd360TourButtonType) {
    //    let id = this.#getButtonId(button);
    //    $(`#${id}`).addClass("d-none");
    //}

    //#getButtonId(button: Sd360TourButtonType): string {
    //    switch (button) {
    //    case Sd360TourButtonType.First:
    //        return "sd360tour-home";
    //    case Sd360TourButtonType.Backward:
    //        return "sd360tour-backward";
    //    case Sd360TourButtonType.Forward:
    //        return "sd360tour-forward";
    //    default:
    //        return "";
    //    }
    //}
}
